import {
	Plugin,
	PluginKey
} from "prosemirror-state";
import {EditorView} from "prosemirror-view";
import {Attrs, Slice} from "prosemirror-model";
import {FormEnvironment} from "@fd/Types.ts";

export const KEY = new PluginKey("intellipaste");

export interface PasteState {}

const URL_REGEX = /^https?:\/\/\S+$/i;

export function intelligentPastePlugin(env:FormEnvironment) {

	function simplifyUrl(url: string): string {
		if (url.startsWith("http://")) url = url.substring(7);
		else if (url.startsWith("https://")) url = url.substring(8);
		const queryIndex = url.indexOf('?');
		if (queryIndex > 0) url = url.substring(0, queryIndex);
		return url;
	}

	function localRelativeUrl(url: string): string {
		let thisPage = new URL(window.location.href);
		let thatPage = new URL(url);
		if (thisPage.host.toLowerCase() === thatPage.host.toLowerCase() && thisPage.port === thatPage.port) {
			// Same host
			let local = thatPage.pathname
			if (Server.context && local.startsWith(Server.context)) local = local.substring(Server.context.length);
			if (local.startsWith('/')) local = local.substring(1);
			let search = thatPage.search;
			const pathIdx = search.indexOf("_sidx_");
			if (pathIdx > 0) search = search.substring(0, pathIdx - 1);	// premove path index from the url
			return local + search;
		}
		return null;
	}

	return new Plugin<PasteState>({
		key: KEY,
		props: {
			handlePaste(view:EditorView, event:ClipboardEvent, slice:Slice) {
				const text = event.clipboardData?.getData("text/plain").trim() ?? "";
				if (!text) return false;

				// Check if it's a URL
				if (URL_REGEX.test(text)) {

					const { state, dispatch } = view;
					const { schema } = state;
					const selectionPos = state.selection.$from.pos;

					// Example 1: insert it as a link mark
					const url = text;
					const relativeUrl = localRelativeUrl(text);
					let linkAttrs:Record<string, string> = { href: relativeUrl ? relativeUrl : url };
					if (!relativeUrl) linkAttrs.target="_blank";
					const linkMark = schema.marks.link.create(linkAttrs);
					const label = relativeUrl ? relativeUrl : simplifyUrl(url);
					const tr = state.tr.insertText(label)
						.addMark(selectionPos, selectionPos + label.length, linkMark);

					dispatch(tr);
					return true;
				}
				return false;
			}
		}
	});
}